import { DEMAND_DESCRIPTION_PLACEHOLDER } from '@/models/healthPlan'
import {
  getHealthPlanTaskComponentsMap,
  HEALTH_PLAN_TASK_TYPE_API_MAP
} from '@/models/healthPlan/tasks'

const mapTaskTypeName = typeFromApi => {
  return HEALTH_PLAN_TASK_TYPE_API_MAP[typeFromApi]
}

const sectionCounters = state => {
  return Object.keys(state.counters)
    .map(typeKey => {
      const type = mapTaskTypeName(typeKey)
      return {
        type,
        counter: state.counters[typeKey]
      }
    })
    .sort(sectionsSortByTypeName)
}

const tasksByDemand = state => {
  if (!state.healthPlanTasks) return {}
  const tasks = {}
  Object.keys(state.healthPlanTasks).forEach(typeKey => {
    const type = mapTaskTypeName(typeKey)
    tasks[type] = groupByDemand(state.healthPlanTasks[typeKey])
  })
  return tasks
}

const groupByDemand = tasks => {
  const groupedByDemand = []
  for (const task of tasks) {
    if (!task.caseRecordDetails.length) {
      const demandTaks = emptyDemand()
      addTaskInDemand(groupedByDemand, demandTaks, task)
    }
    for (const demand of task.caseRecordDetails) {
      addTaskInDemand(groupedByDemand, demand, task)
    }
  }

  return groupedByDemand
}

const addTaskInDemand = (group, demand, task) => {
  const demandGrouped = getDemandInGroup(group, demand)
  if (demandGrouped) {
    demandGrouped.tasks.push(task)
  } else {
    const demandTaks = { ...demand }
    demandTaks.tasks = [task]
    group.push(demandTaks)
  }
  return group
}

const emptyDemand = () => {
  return {
    caseId: '',
    description: {
      description: DEMAND_DESCRIPTION_PLACEHOLDER
    }
  }
}

const getDemandInGroup = (array, demand) => {
  return array.find(
    demandGrouped =>
      demandGrouped.caseId === demand.caseId &&
      demandGrouped.description?.id === demand.description?.id
  )
}

const sectionsSortByTypeName = (sectionA, sectionB) => {
  const itemA = getHealthPlanTaskComponentsMap(sectionA.type)
  const itemB = getHealthPlanTaskComponentsMap(sectionB.type)
  const firstSection = itemA.name
  const secondSection = itemB.name
  if (firstSection < secondSection) {
    return -1
  }
  if (firstSection > secondSection) {
    return 1
  }
  return 0
}
export default {
  sectionCounters,
  tasksByDemand
}
